import PropTypes from "prop-types"
import ModelSelector from "modules/model-selector"
import "./style.scss"

function Subnav({ modelId, modelName, setModel, unsupportedCurrencyWarning, modelIds }) {
  return <div className="watchlist-root-subnav">
    <div className="model-base-info">
      <ModelSelector
        noSpinner
        modelId={modelId}
        modelName={modelName}
        setModel={setModel}
        noRestrictionModels={modelIds}
        disableUnderline
        warningMessage={unsupportedCurrencyWarning}
      />
    </div>
  </div>
}

Subnav.propTypes = {
  modelId: PropTypes.string.isRequired,
  setModel: PropTypes.func.isRequired,
  modelName: PropTypes.string.isRequired,
  unsupportedCurrencyWarning: PropTypes.string,
  modelIds: PropTypes.arrayOf(PropTypes.string),
}

export default Subnav
